import { createSlice } from "@reduxjs/toolkit";

const initialTimetableState = {
  actionsLoading: false,
  sections: [],
  teachers: [],
  timetable: [],
  courseHours: [],
  dayAndHourData: []
};

export const timetableSlice = createSlice({
  name: "timetable",
  initialState: initialTimetableState,
  reducers: {
    startCall: (state) => {
      state.actionsLoading = true;
    },
    // getCurrentTimetable
    currentTimetableFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.authorities = action.payload.authorities;

      if (action.payload.entity) {
        state.sections = action.payload.entity.sections;
        state.teachers = action.payload.entity.teachers;
        state.courseHours = action.payload.entity.courseHours;
        state.timetable = action.payload.entity.timetable;
      }
    },
    // getCoursesSectionsAndTeachers
    listFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.authorities = action.payload.authorities;

      if (action.payload.entity) {
        state.sections = action.payload.entity.sections;
        state.courses = action.payload.entity.courses;
        state.teachers = action.payload.entity.teachers;
        state.courseHours = action.payload.entity.courseHours;
      }
    },
    // getAllTimetable
    allTimetableFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.teachers = action.payload.entity.teachers;
      state.timetable = action.payload.entity.timetable;
    },
    // getTeachersAndTimetable
    teachersAndTimetableFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.teachers = action.payload.entity.teachers;
      state.dayAndHourData = action.payload.entity.dayAndHourData;
    },
    // getTimetable
    timetableFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.dayAndHourData = action.payload.entities;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanTimetableState
    timetableStateCleaned: (state) => {
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.dayAndHourData = [];
    }
  }
});